import React from 'react';
import { Card, CardContent, Grid, Typography, IconButton, Tooltip, Avatar, CircularProgress, Divider } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EditIcon from '@mui/icons-material/Edit';

const HomeProfileCard = ({ userData, requestGetUsuario, setOpenModalEditarPerfil }) => {
    return (
        <Card sx={{ height: '100%', bgcolor: '#f5f5f5', borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                <Grid container alignItems="center" spacing={2} justifyContent="space-between" wrap="nowrap">
                    <Grid item display="flex" alignItems="center" sx={{ minWidth: 0 }}>
                        <Avatar sx={{ width: 48, height: 48, mr: 2, bgcolor: '#e0e0e0', color: 'gray', flexShrink: 0 }}>
                            <AccountCircleIcon sx={{ fontSize: 48 }} />
                        </Avatar>
                        <div style={{ minWidth: 0 }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                ¡Hola {userData?.nombres || ''} {userData?.apellidos || ''}, bienvenido de nuevo!
                            </Typography>
                        </div>
                    </Grid>

                    <Grid item display="flex" alignItems="center">
                        {requestGetUsuario === 'LOADING' ? <CircularProgress size={24} sx={{ mr: 2 }} /> : null}
                        <Tooltip title="Editar Perfil">
                            <IconButton onClick={() => setOpenModalEditarPerfil(true)} sx={{ mr: 1 }}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default HomeProfileCard;
